import { useEffect } from "react";

import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import "./Features.css";
import AOS from "aos";
import "aos/dist/aos.css";
const Features = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    const features = [
        {
            badge: "US Patent 7,643,821",
            icon: "fas fa-comments",
            title: "Conversational SMS in Business",
            desc: "Connect with your subscribers through 2-way, real-time SMS communication via our messenger interface. Build real relationships with your customers.",
            extra:
                "The Conversational SMS for O'Hanlon Patents has been enhanced with AI upgrades, making it even more effective at building customer relationships.",
            linkText: "Read more about AI enhancements",
            link: "/contact",
        },
        {
            badge: "AI-POWERED",
            icon: "fas fa-robot",
            title: "Intelligent Auto-Replies",
            desc: "The AI can now understand the context of incoming messages and provide immediate, accurate responses to common patent-related questions, even after hours.",
            benefits: ["24/7 Availability", "Context-Aware", "Instant Response"],
        },
        {
            badge: "EMOTION AI",
            icon: "fas fa-heart",
            title: "Sentiment Analysis",
            desc: `It can detect the "tone" of a customer's message, helping your team prioritize urgent or frustrated inquiries for a more empathetic response.`,
        },
        {
            badge: "AI AUTOMATION",
            icon: "fas fa-calendar-check",
            title: "Smart Scheduling & Follow-ups",
            desc: "The system can automatically suggest consultation times or send personalized follow-up texts based on the conversation history.",
        },
        {
            badge: "AI SUMMARIZATION",
            icon: "fas fa-file-alt",
            title: "Smart Summarization",
            desc: "For long message threads, the AI can provide a quick summary, allowing your team to get up to speed on a client's history instantly.",
        },
        {
            badge: "US PATENT 9,038,887",
            icon: "fas fa-images",
            title: "AI-Powered MMS & Picture Messaging",
            desc: "The O'Hanlon Patents platform has now expanded its capabilities to include AI-powered MMS and Picture Messaging. Send rich media on every mobile phone with near-100% open rates.",
            patentInfo: [
                "Rich Media Capability: Images, videos, GIFs, and audio files",
                "AI-Enhanced Delivery: Optimizes media for recipient's device",
            ],
            linkText: "Learn more about AI MMS",
            link: "/contact",
        },
    ];
    const aiPlatforms = [
        {
            icon: "fas fa-eye",
            title: "Ask-Jeeves.ai",
            tag: "Accessibility",
            desc: `Utilizes the "Invisible Man" protocol for conversational discovery and proximity-based recognition, ideal for initiating the first touchpoint in your SMS messenger interface.`,
        },
        {
            icon: "fas fa-gem",
            title: "Ask-Genevieve.ai",
            tag: "Strategic",
            desc: `Acts as a confidential AI advisor that prioritizes ethical judgment, perfect for handling high-stakes professional inquiries or complex patent strategy questions via text.`,
        },
        {
            icon: "fas fa-shield",
            title: "Ask-Jeeves-IP.ai",
            tag: "Protection",
            desc: `Serves as the "Truth Supervisor" using neuro-symbolic reasoning to eliminate AI hallucinations, ensuring technical or legal information sent via SMS is factually accurate.`,
        },
        {
            icon: "fas fa-flask",
            title: "Ask-Jeeves-RD.ai",
            tag: "Innovation",
            desc: `Identifies technological "white spaces" while protecting the user's R&D footprint, integrated into SMS flow for clients looking to brainstorm or protect new inventions.`,
        },
    ];
    const geoPlatform = {
        icon: "fas fa-globe",
        title: "Askjeevesgeo.ai",
        tag: "Geospatial Intelligence",
        desc: `Enhances AI capabilities with location-based intelligence and geographic data mapping, enabling smarter proximity analysis and region-specific patent insights within the ecosystem.`,
    };
    const implementationFeatures = [
        {
            title: "Real-Time Media Sharing",
            desc: "Sending rich digital content (images, audio, video) through the SMS interface.",
        },
        {
            title: "Custom Code Integration",
            desc: "AI features like Sentiment Analysis can be hard-coded into your specific control panel.",
        },
        {
            title: "Sovereign Safety",
            desc: `"Privacy by Choice" using Summonable Resonant Intelligent Agent (SRIA) for secure automated responses.`,
        },
    ];
    const visuals = [
        {
            icon: "fas fa-diagram-project",
            title: "Simplify Complex Concepts",
            desc: "Send diagrams or short video explainers of patent processes.",
        },
        {
            icon: "fas fa-handshake",
            title: "Increase Trust",
            desc: "Share high-quality brand imagery and personalized video messages.",
        },
        {
            icon: "fas fa-chart-line",
            title: "Boost Conversions",
            desc: "Use compelling visuals to drive action more effectively than text alone.",
        },
    ];

    const faqs = [
        {
            question: "What makes your AI-enhanced platform unique?",
            answer:
                "TextBrochure contains most modern features found in SMS platforms, but our AI integration sets us apart. We have our own in-house code customization team that can create custom AI features and add them directly to your control panel.",
        },
        {
            question: "Can I see a demonstration of the AI features?",
            answer:
                "Yes! Visit our Contact Us page and request a demo. Our team will contact you within the next business day to set up a personalized demonstration.",
        },
        {
            question: "Can you import my existing contacts to the AI platform?",
            answer:
                "Yes. We can migrate your contacts and even your existing messages if your current provider allows access. Our technical team ensures a smooth migration with zero downtime.",
        },
        {
            question: "How do you ensure patent compliance with AI features?",
            answer:
                "Our platform is built on foundational patents including U.S. Patent No. 7,643,821 and complies with USPTO regulations while integrating AI features safely within the patented framework.",
        },
    ];
    return (
        <>
            <Header />
            {/* <div className="page-wrapper"> */}
            {/* <!-- Hero Section --> */}
            <section className="hero">
                <div className="heros-background"></div>

                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>

                <div className="container">
                    <div className="hero-content">
                        <h1 className="hero-title">AI-Enhanced Platform Features</h1>
                        <p className="hero-subtitle">Discover how Ask Jeeves IP combines patented technology with cutting-edge AI to revolutionize mobile marketing and patent communications.</p>
                    </div>
                </div>
            </section>
            {/* </div> */}
            {/* <!-- Platform Intro --> */}
            <section className="platform-intro">
                <div className="container">
                    <h2>The Future of Conversational SMS</h2>
                    <p><span className="highlight-text">Ask Jeeves IP</span> integrates advanced AI capabilities with our <span className="highlight-text">foundational patents</span> to deliver an unprecedented level of service, automation, and intelligence in mobile communications.</p>
                </div>
            </section>
            {/* <!-- Features Section --> */}
            <section id="features" className="features-section">
                <div className="container">
                    <h2 className="sectionf-title" style={{fontSize: "36px"}}>Core Platform Features</h2>

                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <div className="feature-card" key={index}>
                                <div className="patent-badge">{feature.badge}</div>

                                <div className="feature-icon-wrapper">
                                    <i className={feature.icon}></i>
                                </div>

                                <h3>{feature.title}</h3>
                                <p>{feature.desc}</p>

                                {feature.extra && (
                                    <p>
                                        <strong>{feature.extra}</strong>
                                    </p>
                                )}

                                {feature.benefits && (
                                    <div style={{ marginTop: "15px" }}>
                                        {feature.benefits.map((item, i) => (
                                            <span key={i} className="benefit-tag">
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                )}

                                {feature.patentInfo && (
                                    <div className="patent-info">
                                        {feature.patentInfo.map((info, i) => (
                                            <p key={i}>
                                                <i
                                                    className="fas fa-check-circle"
                                                    style={{ color: "#54A6E9" }}
                                                ></i>{" "}
                                                <strong>{info.split(":")[0]}:</strong>{" "}
                                                {info.split(":")[1]}
                                            </p>
                                        ))}

                                        <Link to={feature.link} className="patent-link">
                                            {feature.linkText}{" "}
                                            <i className="fas fa-external-link-alt"></i>
                                        </Link>
                                    </div>
                                )}

                                {feature.linkText && !feature.patentInfo && (
                                    <Link to={feature.link} className="feature-link">
                                        {feature.linkText} <i className="fas fa-arrow-right"></i>
                                    </Link>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* <!-- Core AI Integration Platforms --> */}
            <section
                className="features-section"
                style={{ background: "#f8fafc", padding: "60px 0" }}
            >
                <div className="container">
                    <h2 className="sectionf-title">Core AI Integration Platforms</h2>

                    <p
                        style={{
                            textAlign: "center",
                            maxWidth: "800px",
                            margin: "0 auto 40px",
                            color: "#666",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Integrating AI upgrades into the O'Hanlon Patents ecosystem involves
                        leveraging the newly launched 2026-compliant O'Hanlon architecture,
                        governed by the Seven Pillars of Excellence.
                    </p>

                    {/* First Grid */}
                    <div className="ai-grid">
                        {aiPlatforms.map((platform, index) => (
                            <div className="ai-card" key={index}>
                                <div
                                    className="feature-icon-wrapper"
                                    style={{
                                        margin: "0 auto 20px",
                                        width: "80px",
                                        height: "80px",
                                        fontSize: "32px",
                                    }}
                                >
                                    <i className={platform.icon}></i>
                                </div>

                                <h3>{platform.title}</h3>
                                <div className="ai-tag">{platform.tag}</div>
                                <p>{platform.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* Second Grid (Geo Platform) */}
                    <div className="ai-grid" style={{ marginTop: "30px" }}>
                        <div
                            className="ai-card"
                            style={{ gridColumn: "span 4", maxWidth: "400px", margin: "0 auto" }}
                        >
                            <div
                                className="feature-icon-wrapper"
                                style={{
                                    margin: "0 auto 20px",
                                    width: "80px",
                                    height: "80px",
                                    fontSize: "32px",
                                }}
                            >
                                <i className={geoPlatform.icon}></i>
                            </div>

                            <h3>{geoPlatform.title}</h3>
                            <div className="ai-tag">{geoPlatform.tag}</div>
                            <p>{geoPlatform.desc}</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Implementation Features Section --> */}
            <section className="features-section" style={{ padding: "60px 0" }}>
                <div className="container">
                    <div className="implementation-box">
                        <h2>
                            <i
                                className="fas fa-cogs"
                                style={{ color: "#54A6E9", marginRight: "15px" }}
                            ></i>
                            Implementation Features
                        </h2>

                        <p
                            style={{
                                color: "#666",
                                marginBottom: "30px",
                                fontSize: "18px",
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            The O'Hanlon platform is built on foundational patents (such as U.S.
                            Patent No. 7,643,821) that enable:
                        </p>

                        <div className="implementation-grid">
                            {implementationFeatures.map((feature, index) => (
                                <div className="implementation-item" key={index}>
                                    <i className="fas fa-check-circle"></i>

                                    <div>
                                        <h4>{feature.title}</h4>
                                        <p>{feature.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div
                            style={{
                                marginTop: "30px",
                                padding: "20px",
                                background: "white",
                                borderRadius: "10px",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    marginBottom: "15px",
                                    fontFamily: "Poppins, sans-serif",
                                }}
                            >
                                If you'd like to see these AI upgrades in action, you can request a
                                demonstration of the "test drive" platform.
                            </p>

                            <Link to={"/contact"}
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    background:
                                        "linear-gradient(135deg, #1D3A90 0%, #54A6E9 100%)",
                                    color: "white",
                                    padding: "12px 30px",
                                    borderRadius: "30px",
                                    textDecoration: "none",
                                    fontWeight: 600,
                                    fontFamily: "Poppins, sans-serif",
                                }}
                            >
                                Request AI Demo <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Building Relationships with Visuals Section --> */}

            <section id="mms" className="visuals-section">
                <div className="container">
                    <div
                        style={{
                            textAlign: "center",
                            maxWidth: "900px",
                            margin: "0 auto",
                        }}
                    >
                        <h2
                            style={{
                                color: "white",
                                fontSize: "42px",
                                marginBottom: "20px",
                                fontFamily: "Montserrat, sans-serif",
                            }}
                        >
                            <i
                                className="fas fa-images"
                                style={{ marginRight: "15px" }}
                            ></i>
                            Building Relationships with Visuals
                        </h2>

                        <p
                            style={{
                                color: "rgba(255,255,255,0.9)",
                                fontSize: "18px",
                                marginBottom: "40px",
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            By incorporating visuals into your communication strategy, you can
                            transform how clients understand and engage with your patent services.
                        </p>

                        <div className="visuals-grid">
                            {visuals.map((item, index) => (
                                <div className="visual-card" key={index}>
                                    <i className={item.icon}></i>
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- FAQ Section --> */}
            <section id="faq" className="faq-section">
                <div className="container">
                    <h2 className="sectionf-title">Frequently Asked Questions</h2>

                    <div className="faq-container">
                        {/* <!-- FAQ 1 --> */}
                        <div className="faq-items">
                            <h3 className="faq-questions">
                                <i className="fas fa-question-circle"></i>
                                What makes your AI-enhanced platform unique?
                            </h3>
                            <div className="faq-answers">
                                <p>TextBrochure contains most modern features found in SMS platforms, but our AI integration sets us apart. What makes our platform unique is that we have our own in-house code customization team that can create custom AI features and add them directly to your control panel.</p>
                                <p>Additionally, we comply with all laws, rules and regulations, with licensing agreements to ensure you're protected. This compliance extends to patents issued by the United States Patent and Trademark Office, including U.S. Patent No. 7,643,821.</p>
                                <p>For more information visit our <Link to={"/about"} class="faq-link">About Us page</Link>.</p>
                            </div>
                        </div>

                        {/* <!-- FAQ 2 --> */}
                        <div className="faq-items">
                            <h3 className="faq-questions">
                                <i className="fas fa-question-circle"></i>
                                Can I see a demonstration of the AI features?
                            </h3>
                            <div className="faq-answers">
                                <p>Absolutely! Please click the <Link to={"/contact"} class="faq-link">Contact Us</Link> page and let us know you'd like to experience our AI-enhanced platform. Someone will contact you within the next business day to set up your personalized demo where you can explore all AI features including Intelligent Auto-Replies, Sentiment Analysis, and Smart Summarization.</p>
                            </div>
                        </div>

                        {/* <!-- FAQ 3 --> */}
                        <div className="faq-items">
                            <h3 className="faq-questions">
                                <i className="fas fa-question-circle"></i>
                                Can you import my existing contacts to the AI platform?
                            </h3>
                            <div className="faq-answers">
                                <p>Yes! We will be able to migrate your contacts over seamlessly. If your current provider grants us access, we can migrate your existing messages as well. We have a dedicated team of technology professionals who will handle everything, ensuring zero downtime for your business while activating AI features on your existing subscriber base.</p>
                            </div>
                        </div>

                        {/* <!-- FAQ 4 --> */}
                        <div className="faq-items">
                            <h3 className="faq-questions">
                                <i className="fas fa-question-circle"></i>
                                How do you ensure patent compliance with AI features?
                            </h3>
                            <div className="faq-answers">
                                <p>Our platform is built on foundational patents (U.S. Patent No. 7,643,821) that cover the process of sending multi-media-capable content to mobile phones. The AI features operate within this patented framework, and we maintain strict compliance with all USPTO regulations. Ask-Jeeves-IP.ai serves as our "Truth Supervisor," using neuro-symbolic reasoning to eliminate AI hallucinations and ensure all information is factually accurate.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="ctaf-section">
                <div className="container">
                    <h2 className="ctaf-title">Ready to Experience AI-Enhanced Patent Communications?</h2>
                    <p className="ctaf-text">Join forward-thinking organizations using Ask Jeeves IP to engage clients, protect intellectual property, and grow their practice with AI-powered text messaging solutions built on patented technology.</p>

                    <div className="ctaf-buttons">
                        <Link to={"/about"} className="cta-btn-primary">Request Platform Demo</Link>
                        <Link to={"/contact"} className="cta-btn-secondary">Speak with AI Specialist</Link>
                    </div>
                    <p className="patent-footer"><i className="fas fa-shield-alt"></i> Protected by U.S. Patent Nos. 7,643,821 | 8,437,453 | 8,817,959 | 8,774,371 | 9,038,887</p>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Features;